<template>
  <div class="hl" :class="{'is-loaded': ($root.hlink.length > 0)}">
    
    <a href="#" class="hl__item">{{country.name}} <img :src="`/assets/flags/${country.code}.svg`" alt="" class="hl__flag"></a>

    <a target="_blank" href="http://porntourist.com/?ref=getsex" class="hl__item">
      <img src="/assets/porntourist.svg" alt="">  PornTourist
    </a>

    <a class='hl__item nopop' :id='n.id' v-for='n in $root.hlink' :key='n.href' target='_blank' :href='n.href' rel='nofollow' :style="n.icon ? 'position: relative;' : ''"><object v-if='n.icon' type='image/svg+xml' :data='n.icon' class='hl__flag' style='display: block; width: 14px; height: 14px;'></object>{{n.title}}</a>

    <a :href="`https://${i}`" target="_blank" v-for="(i,key) in items" class="hl__item" :key="key">{{key}}</a>
  </div>
</template>


<style lang="scss">
.hl {
  display: flex;
  width: 100%;
  height: 28px;
  padding: 0 14px;
  overflow-y: hidden;
  overflow-x: scroll;
  white-space: nowrap;
  scrollbar-width: none;
  transform: translateX(-100px);
  will-change: transform;
  opacity: 0;
  font-size: 0;
  margin-bottom: 13px;
  &::-webkit-scrollbar {
    display: none;
  }

  @include mq('md') {
    display: none;
  }
  &.is-loaded {
    opacity: 1;
    transition: all .5s ease;
    transform: translateX(0);
  }
  &__flag {
    width: 16px;
    position: relative;
    top: 1px;
  }
  &__item {
    display: inline-flex;
    flex-shrink: 0;
    gap: 5px;
    align-items: center;
    padding: 8px 8px;
    background: #1e1926;
    font-size: 12px;
    height: 28px;
    overflow: hidden;
    outline: none;
    color: $color-link;
    &:hover {
      color: $color-link;
    }
    &:not(:last-child) {
      margin-right: 8px;
    }

    @supports (-moz-appearance:none) {
      &:last-child {
        margin-right: 14px;
      }
    }
    
  }
}


</style>


<script>

import axios from 'axios';

const popularCountries = {
  'ec':'brazilian',
  'al':'albania',
  'dz':'europe',
  'ar':'argentina',
  'am':'armenia',
  'au':'australian',
  'at':'austria',
  'az':'latina',
  'by':'austria',
  'be':'belgium',
  'ba':'european',
  'br':'brazilian',
  'bg':'bulgaria',
  'kh':'cambodia',
  'ca':'canadian',
  'cl':'chile',
  'cn':'chinese',
  'co':'colombian',
  'cr':'latina',
  'hr':'european',
  'cw':'latina',
  'cy':'european',
  'cy':'cyprus',
  'cz':'czech',
  'dk':'danish',
  'do':'dominican',
  'eg':'egyptian',
  'ee':'european',
  'eu':'european',
  'fi':'finnish',
  'fr':'francaise',
  'ge':'european',
  'de':'germany',
  'gr':'greek',
  'gt':'latina',
  'hn':'latina',
  'hu':'european',
  'in':'indian',
  'id':'indonesia',
  'iq':'arab',
  'ie':'irish',
  'il':'israel',
  'it':'italian',
  'jo':'latina',
  'je':'black',
  'kg':'arab',
  'lv':'european',
  'lt':'european',
  'lu':'european',
  'mo':'chinese',
  'mk':'european',
  'my':'asian',
  'mu':'black',
  'mx':'mexican',
  'md':'romanian',
  'mn':'asian',
  'ma':'latina',
  'mm':'asian',
  'mm':'asian',
  'nl':'dutch',
  'nz':'european',
  'ni':'latina',
  'ng':'black',
  'no':'norwegian',
  'pk':'pakistan',
  'ps':'arab',
  'pa':'latina',
  'ph':'asian',
  'pl':'polish',
  'pt':'portuguese',
  'pr':'latina',
  'ro':'romanian',
  'ro':'romanian',
  'ru':'russian',
  'sv':'latina',
  'rs':'serbian',
  'sg':'asian',
  'sk':'european',
  'za':'african',
  'za':'african',
  'es':'spanish',
  'lk':'black',
  'se':'swedish',
  'ch':'european',
  'sy':'arab',
  'tw':'taiwan',
  'th':'thailand',
  'kr':'korean',
  'tt':'latina',
  'tn':'arab',
  'us':'american',
  'ua':'ukrainian',
  'gb':'england',
  'uy':'latina',
  'uz':'asian',
  've':'latina',
  'vn':'vietnam'
};

export default {
  data: () => ({
    country: {
      code: 'en',
      name: ''
    },
    items: {
      "See.xxx": "see.xxx",
      "tPorn.xxx": "tporn.xxx",
      "PornJ": "pornj.com",
      "PornQ": "pornq.com"
    },

  }),
  computed: {
    link() {
      return `https://${location.host}/${this.$root.state.lang}/search/?search=${popularCountries[this.country.code]}`;
    }
  },
  methods: {
    loadCountry() {
      axios.get('/get_country.php').then((res)=>{
        const data = res.data;
        this.country.name = data.country_name;
        this.country.code = data.country_code;
      })
    }
  },
  created() {
    this.loadCountry();
  }

}
</script>